import { render, staticRenderFns } from "./SubmitDocumentsModal.vue?vue&type=template&id=6c8b1d6a&scoped=true"
import script from "./SubmitDocumentsModal.vue?vue&type=script&lang=js"
export * from "./SubmitDocumentsModal.vue?vue&type=script&lang=js"
import style0 from "./SubmitDocumentsModal.vue?vue&type=style&index=0&id=6c8b1d6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8b1d6a",
  null
  
)

export default component.exports